import React, { useEffect, useState, useContext } from "react";
import { CoreContainer, Notification, Icon } from "../common/style";
import { getProjectsForUser, createUserProject } from "../project/service";
import OrderInfo from "./OrderInfo";
import { CardBody } from "reactstrap";
import { Card, CardGroup } from "../product/style";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  Spinner,
  Card as ReactStrapCard,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import NewProjectModal from "../project/NewProjectModal";
import { fetchOrganizationData, isInternalAccess } from "../common/service";
import { isBrowser, isMobile, isMobileOnly } from "react-device-detect";
import { AppContext } from "../context";
import { getCurrentUser } from "../auth/service";
import { Header } from "../common";
import { cloneProject } from "./service";
import ConfirmationModal from "./ConfirmationModal";
import SampleOrdersModal from "./SampleOrdersModal";
import MobileBanner from "../common/MobileBanner";
// Sample Orders
const sampleOrders = [
  {
    id: 2291,
    name: "7 feet Wardrobe",
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/sample-orders/7_feet_wardrobe.jpg",
  },
];

const ProjectCard = (props) => {
  const [cloneConfirmationOpen, setCloneConfirmationOpen] = useState(false);
  const [createChildConfirmationOpen, setCreateChildConfirmationOpen] = useState(false);
  const [additionalProjectsPanelOpen, setAdditionalProjectsPanelOpen] = useState(false);

  const toggleCloneConfirmationState = () => {
    setCloneConfirmationOpen((prevState) => !prevState);
  };

  const toggleCreateChildConfirmationState = () => {
    setCreateChildConfirmationOpen((prevState) => !prevState);
  };

  const clonedProject = () => {
    props.setIsLoading(true);
    return cloneProject({
      projectId: props.id,
      project: { type: "project", id: props.id },
    })
      .then((response) => {
        props.getProjects();
      })
      .catch(({ error }) => {
        props.setIsNotificationVisible(true);
        props.setNotification({ type: "error", message: error });
      })
      .finally(() => {
        props.setIsLoading(false);
      });
  };

  const createChildProject = () => {
    props.setIsLoading(true);
    return createUserProject({
      name: `${props.name} / Additional`,
      version: 2,
      parent_project_id: props.id,
    })
      .then((response) => {
        props.setIsNotificationVisible(true);
        props.setNotification({
          type: "success",
          message: response.message || "Child project created successfully",
        });
        props.getProjects();
        if (response.project_id) {
          props.navigate(`/projects/${response.project_id}`);
        }
      })
      .catch(({ error }) => {
        props.setIsNotificationVisible(true);
        props.setNotification({ type: "error", message: error });
      })
      .finally(() => {
        props.setIsLoading(false);
      });
  };

  const handleCloneClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    toggleCloneConfirmationState();
  };

  const handleCreateChildClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    toggleCreateChildConfirmationState();
  };

  const getParentAndAdditionalProjects = () => {
    if (!props.hasAdditionalProject) {
      return { parentProject: null, additionalProjects: [] };
    }

    const parentProject = props;

    const additionalProjects = props.childProjects || [];

    return { parentProject, additionalProjects };
  };

  const formatStatus = (status) => {
    if (!status) return "";
    return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ");
  };

  const formatWithOrdinal = (date) => {
    if (!date) return null;
    try {
      const d = new Date(date);
      const day = d.getDate();
      const j = day % 10,
        k = day % 100;
      let suffix = "th";
      if (j === 1 && k !== 11) suffix = "st";
      else if (j === 2 && k !== 12) suffix = "nd";
      else if (j === 3 && k !== 13) suffix = "rd";
      const month = d.toLocaleString("en-US", { month: "short" });
      return `${month} ${day}${suffix}`;
    } catch (e) {
      return date;
    }
  };

  const formatDeliveryRange = (fromDate, toDate) => {
    if (!fromDate && !toDate) return null;
    if (fromDate && !toDate) return formatWithOrdinal(fromDate);
    if (!fromDate && toDate) return formatWithOrdinal(toDate);
    try {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      const sameMonth =
        from.getFullYear() === to.getFullYear() &&
        from.getMonth() === to.getMonth();
      if (sameMonth) {
        const month = from.toLocaleString("en-US", { month: "short" });
        // show like: Nov 20th - 28th
        const leftDay = from.getDate();
        const rightDay = to.getDate();
        const suffix = (n) => {
          const j = n % 10,
            k = n % 100;
          if (j === 1 && k !== 11) return "st";
          if (j === 2 && k !== 12) return "nd";
          if (j === 3 && k !== 13) return "rd";
          return "th";
        };
        return `${month} ${leftDay}${suffix(leftDay)} - ${rightDay}${suffix(
          rightDay
        )}`;
      }
      // different months: Nov 28th - Dec 2nd
      return `${formatWithOrdinal(fromDate)} - ${formatWithOrdinal(toDate)}`;
    } catch (e) {
      return `${formatWithOrdinal(fromDate)} - ${formatWithOrdinal(toDate)}`;
    }
  };

  const createProjectSummary = () => {
    return {
      id: props.id,
      order_id: props.orderId,
      order_status: props.orderStatus,
      actual_status: props.actualStatus || props.orderStatus,
      action_buttons: props.actionButtons || [],
      action_button_text: props.actionButtonText,
      is_price_stale: props.isPriceStale,
      has_any_module_errors: props.hasModuleErrors,
      is_template_stale: props.isTemplateStale,
      is_delivery_date_stale: props.deliveryDateStale,
      planned_delivery_date: props.plannedDeliveryDate,
      delivery_date_from: props.deliveryDateFrom,
      delivery_date_to: props.deliveryDateTo,
      is_support: props.isSupport,
    };
  };

  const isDraftProject = () => {
    const status = props.orderStatus?.toLowerCase();
    // Draft: not placed and not delivered
    const isPlaced = props.orderId && (status === "placed" || status === "production_planning" || status === "production" || status === "partially_delivered");
    const isDelivered = status === "delivered";
    return !isPlaced && !isDelivered;
  };

  const getProjectUrl = () => {
    return isDraftProject()
      ? `/projects/${props.id}`
      : `/projects/${props.id}/order_details`;
  };

  return (
    <>
      <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mt-3">
        <Card height="auto" className="h-100" style={{ position: "relative" }}>
          <Link
            className="text-decoration-none flex-grow-1"
            to={getProjectUrl()}
          >
            <CardBody className="d-flex flex-column justify-content-between h-100" style={{ padding: "0.75rem" }}>
              {/* Row 1: Project name, status, and menu */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="fw-bold fs-5 text-black" title={props.name}>
                  {props.name}
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="badge bg-secondary text-nowrap">
                    {formatStatus(props.orderStatus)}
                  </span>
                  {props.hasAdditionalProject && (
                    <a
                      className="pointer me-1"
                      style={{ color: "#0d6efd" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        setAdditionalProjectsPanelOpen(true);
                      }}
                      title="View Additional Projects"
                    >
                      Additionals
                    </a>
                  )}
                  <UncontrolledDropdown
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                  >
                    <DropdownToggle
                      className="border-0 p-1 text-dark"
                      style={{ background: "transparent" }}
                    >
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <DropdownItem onClick={handleCloneClick}>
                        <Icon
                          className="fa-regular fa-clone me-2"
                          size="12px"
                        />
                        Duplicate Project
                      </DropdownItem>
                      <DropdownItem
                        onClick={props.can_add_additional !== false ? handleCreateChildClick : undefined}
                        disabled={props.can_add_additional === false}
                        id={`additional-project-tooltip-${props.id}`}
                        style={props.can_add_additional === false ? { cursor: "not-allowed", opacity: 0.6 } : {}}
                      >
                        <Icon
                          className="fa-solid fa-plus me-2"
                          size="12px"
                        />
                        Create Additional Project
                      </DropdownItem>
                      {props.can_add_additional === false && (
                        <UncontrolledTooltip
                          target={`additional-project-tooltip-${props.id}`}
                          placement="left"
                        >
                          Available only for placed project
                        </UncontrolledTooltip>
                      )}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>

              {/* Row 2: Price and action button */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                {props.canAccessPrice && props.price !== null ? (
                  <div className="fw-semibold" style={{ fontSize: "0.85rem" }}>
                    <span style={{ color: "#666666" }}>₹{Number(props.price).toLocaleString("en-IN")}</span> <span style={{ color: "#9aa0a6", fontSize: "0.7rem" }}>(incl. GST)</span>
                  </div>
                ) : (
                  <div></div>
                )}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <OrderInfo
                    projectSummary={createProjectSummary()}
                    setProjectSummary={(updatedSummary) => {
                      props.getProjects();
                    }}
                    setCurrentTab={() => {}}
                    reloadRoom={() => {}}
                    fromProjectCard={true}
                  />
                </div>
              </div>

              {/* Row 3: User name and delivery date */}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <p className="m-0 text-secondary" style={{ fontSize: "0.875rem" }}>{props.owner}</p>
                </div>
                <div>
                  {(() => {
                    const status = props.orderStatus?.toLowerCase();
                    const isDelivered = status === "delivered" || status === "delivered_a";

                    // Don't show ETA or delivered_at if status is delivered
                    if (isDelivered) {
                      return null;
                    }

                    if ((props.deliveryDateFrom || props.deliveryDateTo) && !props.deliveryDateStale) {
                      return (
                        <small className="text-muted">
                          ETA: {formatDeliveryRange(props.deliveryDateFrom, props.deliveryDateTo)}
                        </small>
                      );
                    } else {
                      return (
                        <small className="text-muted">ETA: Not available</small>
                      );
                    }
                  })()}
                </div>
              </div>
            </CardBody>
          </Link>
        </Card>
      </div>

      <ConfirmationModal
        isOpen={cloneConfirmationOpen}
        toggle={toggleCloneConfirmationState}
        onConfirm={() => {
          clonedProject();
          setCloneConfirmationOpen(false);
        }}
        message={`Are you sure you want to duplicate?`}
        headingText="Confirmation"
      />
      <ConfirmationModal
        isOpen={createChildConfirmationOpen}
        toggle={toggleCreateChildConfirmationState}
        onConfirm={() => {
          createChildProject();
          setCreateChildConfirmationOpen(false);
        }}
        message={`Are you sure you want to create an additional project?`}
        headingText="Confirmation"
      />

      {additionalProjectsPanelOpen && (
        <AdditionalProjectsPanel
          isOpen={additionalProjectsPanelOpen}
          onClose={() => setAdditionalProjectsPanelOpen(false)}
          currentProject={props}
          allProjects={props.allProjects}
          navigate={props.navigate}
        />
      )}
    </>
  );
};

const AdditionalProjectsPanel = ({ isOpen, onClose, currentProject, allProjects, navigate }) => {
  const { parentProject, additionalProjects } = React.useMemo(() => {
    if (!currentProject.hasAdditionalProject || !allProjects) {
      return { parentProject: null, additionalProjects: [] };
    }

    const parent = currentProject;

    const additionalProjectIds = parent.additional_project_id || parent.additionalProjectId || [];
    const additional = allProjects.filter(
      (p) => Array.isArray(additionalProjectIds) && additionalProjectIds.includes(p.id)
    );

    return { parentProject: parent, additionalProjects: additional };
  }, [currentProject, allProjects]);

  const formatStatus = (status) => {
    if (!status) return "";
    return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ");
  };

  const createProjectSummary = (project) => {
    return {
      id: project.id,
      order_id: project.order_id,
      order_status: project.order_status || project.status,
      actual_status: project.actual_status || project.order_status || project.status,
      action_buttons: project.action_buttons || [],
      action_button_text: project.action_button_text,
      is_price_stale: project.is_price_stale,
      has_any_module_errors: project.has_any_module_errors,
      is_template_stale: project.is_template_stale,
      is_delivery_date_stale: project.delivery_date_stale,
      planned_delivery_date: project.planned_delivery_date,
      delivery_date_from: project.delivery_date_from,
      delivery_date_to: project.delivery_date_to,
    };
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
          transition: "opacity 0.3s ease",
          opacity: isOpen ? 1 : 0,
          pointerEvents: isOpen ? "auto" : "none",
        }}
        onClick={onClose}
      />

      <div
        style={{
          position: "fixed",
          top: 0,
          right: isOpen ? 0 : "-25%",
          width: "25%",
          height: "100vh",
          backgroundColor: "white",
          boxShadow: "-2px 0 8px rgba(0, 0, 0, 0.15)",
          zIndex: 1050,
          transition: "right 0.3s ease",
          overflowY: "auto",
          padding: "20px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
          <div>
            {parentProject && (
              <div>
                <div className="fw-bold fs-5 mb-2">{parentProject.name}</div>
                <span className="badge bg-secondary">
                  {formatStatus(parentProject.actualStatus || parentProject.orderStatus)}
                </span>
              </div>
            )}
          </div>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onClose}
          >
            <i className="fa-solid fa-times"></i>
          </button>
        </div>

        <div>
          {additionalProjects.length > 0 ? (
            <Table
              size="sm"
              bordered
              hover
              responsive
            >
              <thead style={{ backgroundColor: "#343a40", color: "white" }}>
                <tr>
                  <th style={{ backgroundColor: "#343a40", color: "white" }}>Name</th>
                  <th style={{ backgroundColor: "#343a40", color: "white" }}>Status</th>
                  <th style={{ backgroundColor: "#343a40", color: "white" }}>Price</th>
                  <th style={{ backgroundColor: "#343a40", color: "white" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {additionalProjects.map((project, index) => (
                  <tr
                    key={project.id || index}
                    style={{ cursor: project.id ? "pointer" : "default" }}
                    onClick={(e) => {
                      if (e.target.tagName === 'BUTTON' || e.target.closest('button') || e.target.closest('td:last-child')) {
                        return;
                      }
                      if (project.id) {
                        navigate(`/projects/${project.id}`);
                        onClose();
                      }
                    }}
                  >
                    <td className="text-dark">
                      {project.name}
                    </td>
                    <td className="text-dark">
                      {formatStatus(project.order_status || project.status)}
                    </td>
                    <td className="text-dark">
                      {project.price !== null && project.price !== undefined
                        ? `₹${Number(project.price).toLocaleString("en-IN")}`
                        : "-"}
                    </td>
                    <td
                      onClick={(e) => e.stopPropagation()}
                    >
                      {project.action_buttons && project.action_buttons.length > 0 ? (
                        <OrderInfo
                          projectSummary={createProjectSummary(project)}
                          setProjectSummary={() => {}}
                          setCurrentTab={() => {}}
                          reloadRoom={() => {}}
                          fromProjectCard={true}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p className="text-muted">No additional projects found.</p>
          )}
        </div>
      </div>
    </>
  );
};

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const navigate = useNavigate();
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [addProjectModal, setAddProjectModal] = useState(false);
  const [sampleModalOpen, setSampleModalOpen] = useState(false);
  const [loadingProjectId, setLoadingProjectId] = useState(null);
  const stateValue = useLocation().state;
  const { setOrganizationData } = useContext(AppContext);
  const [searchParams] = useSearchParams();
  const [isCanvasSupported, setIsCanvasSupported] = useState(false);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("draft");

  const toggleAddProjectModal = () => setAddProjectModal(!addProjectModal);
  const toggleSampleModal = () => setSampleModalOpen(!sampleModalOpen);

  const getProjects = () => {
    setIsLoading(true);

    getProjectsForUser({
      org_id: searchParams.get("org_id") || "",
      status: searchParams.get("status") || "",
    })
      .then((response) => {
        setIsCanvasSupported(response.is_canvas_supported);
        setProjects(response.projects);
      })
      .catch((err) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: err.error });
      })
      .finally((_) => setIsLoading(false));
  };

  const getDraftProjects = () => {
    return projects.filter((project) => {
      const status = project.order_status || project.status;
      const isPlaced = project.order_id && (status === "placed" || status === "production_planning" || status === "production" || status === "partially_delivered");
      const isDelivered = status === "delivered";
      return !isPlaced && !isDelivered;
    });
  };

  const getPlacedProjects = () => {
    return projects.filter((project) => {
      const status = project.order_status || project.status;
      return project.order_id && (status === "placed"|| status === "production_planning" || status === "production" || status === "partially_delivered");
    });
  };

  const getDeliveredProjects = () => {
    return projects.filter((project) => {
      const status = project.order_status || project.status;
      return  status === "delivered";
    });
  };

  const getFilteredProjects = () => {
    let projectsToShow = [];
    if (activeTab === "draft") {
      projectsToShow = getDraftProjects();
    } else if (activeTab === "placed") {
      projectsToShow = getPlacedProjects();
    } else if (activeTab === "delivered") {
      projectsToShow = getDeliveredProjects();
    }
    return projectsToShow.filter((project) => {
      // Hide projects with additional_project or support_project set to true
      if (project.additional_project === true) {
        return false;
      }
      return project.name?.toLowerCase().includes(search.toLowerCase());
    });
  };

  useEffect(() => {
    getProjects();
  }, []);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const createProject = ({ payload: { name, version } }) => {
    setIsLoading(true);

    return createUserProject({
      name,
      version: version,
    })
      .then((response) => {
        setIsNotificationVisible(true);
        setNotification({
          type: "success",
          message: response.message,
        });

        const currentUser = getCurrentUser();

        if (currentUser) {
          fetchOrganizationData(currentUser.org_id).then((orgData) => {
            setOrganizationData(orgData);
          });
        }
        navigate(`${response.project_id}${isMobile ? "/cutlist" : ""}`);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const handleTryNowClick = (sampleProjectId, sampleProjectName) => {
    setLoadingProjectId(sampleProjectId);
    cloneProject({
      projectId: sampleProjectId,
      project: {
        type: "project",
        id: sampleProjectId,
        name: sampleProjectName,
      },
    })
      .then((response) => {
        navigate(`/projects/${response.clone_items.id}`);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => {
        setLoadingProjectId(null);
        setSampleModalOpen(false);
      });
  };

  return isLoading || isLoading === null ? (
    <CoreContainer>
      <Spinner>Loading...</Spinner>
    </CoreContainer>
  ) : (
    <>
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}
      <Header nav={true} toggleSampleModal={toggleSampleModal} />
      {isMobileOnly && <MobileBanner />}
      <div className="bg-light border-bottom">
        <div className="container-fluid px-4">
          <div className="row align-items-center" style={{ minHeight: 80 }}>
            <div className="col-md-6 col-12 py-3">
              <input
                type="search"
                className="form-control fs-6 p-2 w-100"
                style={{ maxWidth: "500px" }}
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-6 col-12 text-md-end text-start py-3">
              <Button color="primary" onClick={toggleAddProjectModal} size="lg">
                Add Project
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid px-4 pt-4">
        {/* Tab Navigation */}
        <Nav tabs className="mb-4">
          <NavItem>
            <NavLink
              className={`cursor-pointer ${
                activeTab === "draft" ? "active" : ""
              }`}
              onClick={() => setActiveTab("draft")}
            >
              Draft ({getDraftProjects().length})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`cursor-pointer ${
                activeTab === "placed" ? "active" : ""
              }`}
              onClick={() => setActiveTab("placed")}
            >
              Placed ({getPlacedProjects().length})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`cursor-pointer ${
                activeTab === "delivered" ? "active" : ""
              }`}
              onClick={() => setActiveTab("delivered")}
            >
              Delivered ({getDeliveredProjects().length})
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Content */}
        <TabContent activeTab={activeTab}>
          <TabPane tabId="draft">
            {activeTab === "draft" && (
              <>
                {getFilteredProjects().length > 0 ? (
                  <CardGroup className="row" browser={isBrowser.toString()}>
                    {getFilteredProjects().map((project, index) => (
                      <ProjectCard
                        key={index}
                        id={project.id}
                        name={project.name}
                        value={project.value}
                        owner={project.owner?.name}
                        canAccessPrice={project.owner?.can_access_price}
                        price={project.price}
                        orderStatus={project.order_status || project.status}
                        actualStatus={project.actual_status}
                        orderId={project.order_id}
                        actionButtons={project.action_buttons}
                        actionButtonText={project.action_button_text}
                        isPriceStale={project.is_price_stale}
                        hasModuleErrors={project.has_any_module_errors}
                        isTemplateStale={project.is_template_stale}
                        deliveryDate={project.delivery_date}
                        plannedDeliveryDate={project.planned_delivery_date}
                        deliveryDateFrom={project.delivery_date_from}
                        deliveryDateTo={project.delivery_date_to}
                        deliveryDateStale={project.delivery_date_stale}
                        deliveredAt={project.delivered_at}
                        getProjects={getProjects}
                        setIsLoading={setIsLoading}
                        setIsNotificationVisible={setIsNotificationVisible}
                        setNotification={setNotification}
                        navigate={navigate}
                        meta={project.meta}
                        hasAdditionalProject={project.has_additional_project}
                        additionalProjectId={project.additional_project_id}
                        allProjects={projects}
                        can_add_additional={project.can_add_additional}
                        isSupport={project.is_support}
                      />
                    ))}
                  </CardGroup>
                ) : (
                  <div className="text-center rounded border shadow py-5 mt-2">
                    <div className="fs-2 fw-bold mb-4">Welcome to Boxs!</div>
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        type="button"
                        className="btn btn-primary fs-6 p-3"
                        onClick={toggleSampleModal}
                      >
                        Explore Sample Orders
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary fs-6 p-3"
                        onClick={toggleAddProjectModal}
                      >
                        Create first project
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </TabPane>

          <TabPane tabId="placed">
            {activeTab === "placed" && (
              <>
                {getFilteredProjects().length > 0 ? (
                  <CardGroup className="row" browser={isBrowser.toString()}>
                    {getFilteredProjects().map((project, index) => (
                      <ProjectCard
                        key={index}
                        id={project.id}
                        name={project.name}
                        value={project.value}
                        owner={project.owner?.name}
                        canAccessPrice={project.owner?.can_access_price}
                        price={project.price}
                        orderStatus={project.order_status || project.status}
                        actualStatus={project.actual_status}
                        orderId={project.order_id}
                        actionButtons={project.action_buttons}
                        actionButtonText={project.action_button_text}
                        isPriceStale={project.is_price_stale}
                        hasModuleErrors={project.has_any_module_errors}
                        isTemplateStale={project.is_template_stale}
                        deliveryDate={project.delivery_date}
                        plannedDeliveryDate={project.planned_delivery_date}
                        deliveryDateFrom={project.delivery_date_from}
                        deliveryDateTo={project.delivery_date_to}
                        deliveryDateStale={project.delivery_date_stale}
                        deliveredAt={project.delivered_at}
                        getProjects={getProjects}
                        setIsLoading={setIsLoading}
                        setIsNotificationVisible={setIsNotificationVisible}
                        setNotification={setNotification}
                        navigate={navigate}
                        meta={project.meta}
                        hasAdditionalProject={project.has_additional_project}
                        additionalProjectId={project.additional_project_id}
                        allProjects={projects}
                        isSupport={project.is_support}
                      />
                    ))}
                  </CardGroup>
                ) : (
                  <div className="text-center rounded border shadow py-5 mt-2">
                    <div className="fs-4 fw-bold mb-4">
                      No Placed Projects
                    </div>
                    <p className="text-muted">
                      Projects with placed orders will appear here.
                    </p>
                  </div>
                )}
              </>
            )}
          </TabPane>

          <TabPane tabId="delivered">
            {activeTab === "delivered" && (
              <>
                {getFilteredProjects().length > 0 ? (
                  <CardGroup className="row" browser={isBrowser.toString()}>
                    {getFilteredProjects().map((project, index) => (
                      <ProjectCard
                        key={index}
                        id={project.id}
                        name={project.name}
                        value={project.value}
                        owner={project.owner?.name}
                        canAccessPrice={project.owner?.can_access_price}
                        price={project.price}
                        orderStatus={project.order_status || project.status}
                        actualStatus={project.actual_status}
                        orderId={project.order_id}
                        actionButtons={project.action_buttons}
                        actionButtonText={project.action_button_text}
                        isPriceStale={project.is_price_stale}
                        hasModuleErrors={project.has_any_module_errors}
                        isTemplateStale={project.is_template_stale}
                        deliveryDate={project.delivery_date}
                        plannedDeliveryDate={project.planned_delivery_date}
                        deliveryDateFrom={project.delivery_date_from}
                        deliveryDateTo={project.delivery_date_to}
                        deliveryDateStale={project.delivery_date_stale}
                        deliveredAt={project.delivered_at}
                        getProjects={getProjects}
                        setIsLoading={setIsLoading}
                        setIsNotificationVisible={setIsNotificationVisible}
                        setNotification={setNotification}
                        navigate={navigate}
                        meta={project.meta}
                        hasAdditionalProject={project.has_additional_project}
                        additionalProjectId={project.additional_project_id}
                        allProjects={projects}
                        can_add_additional={project.can_add_additional}
                        isSupport={project.is_support}
                      />
                    ))}
                  </CardGroup>
                ) : (
                  <div className="text-center rounded border shadow py-5 mt-2">
                    <div className="fs-4 fw-bold mb-4">
                      No Delivered Projects
                    </div>
                    <p className="text-muted">
                      Completed projects will appear here.
                    </p>
                  </div>
                )}
              </>
            )}
          </TabPane>
        </TabContent>
      </div>

      <NewProjectModal
        isOpen={addProjectModal}
        toggle={toggleAddProjectModal}
        onSuccess={(payload) => createProject({ payload })}
        isCanvasSupported={isCanvasSupported}
      />

      <SampleOrdersModal
        isOpen={sampleModalOpen}
        toggle={toggleSampleModal}
        sampleOrders={sampleOrders}
        loadingProjectId={loadingProjectId}
        handleTryNowClick={handleTryNowClick}
      />
    </>
  );
};

export default Projects;
